import type { QueryFunctionContext } from '@tanstack/vue-query';

import type { ApiResponse } from '@abaninja/types';

import { httpClient } from '@abaninja/util-http-client';
import { apiClient } from '@abaninja/util-http-client';

import type { DigitalCoachProfile, DigitalCoachProfileRequest } from '../@types';
import type { DigitalCoach, DigitalCoachRequest, FavorizeDigitalCoachRequest } from '../@types';

export async function getDigitalCoaches(options?: QueryFunctionContext) {
  return (await apiClient.get<ApiResponse<DigitalCoach[]>>(
    '/digital-coaches/v1/digital-coaches',
    { signal: options?.signal },
  )).data;
}

export async function createDigitalCoach(data: DigitalCoachRequest) {
  return (await apiClient.post<ApiResponse<DigitalCoach>>('/digital-coaches/v1/digital-coaches', data)).data;
}

export async function removeDigitalCoach(uuid: string) {
  return (await apiClient.delete(`/digital-coaches/v1/digital-coaches/${uuid}`)).data;
}

export async function favorizeDigitalCoach({ isFavourite, uuid }: FavorizeDigitalCoachRequest) {
  return (await apiClient.patch<ApiResponse<DigitalCoach>>(
    `/digital-coaches/v1/digital-coaches/${uuid}`,
    { isFavourite },
  )).data;
}

export async function getDigitalCoachProfile(options?: QueryFunctionContext) {
  return (await httpClient.get<ApiResponse<DigitalCoachProfile>>('/digital-coaches/v1/me', {
    signal: options?.signal,
  })).data;
}

export async function updateDigitalCoachProfile(data: DigitalCoachProfileRequest) {
  return (await httpClient.patch<ApiResponse<DigitalCoachProfile>>('/digital-coaches/v1/me', data)).data;
}

export async function uploadPhoto(photo: File) {
  return (await httpClient.postForm<ApiResponse<DigitalCoachProfile>>(`/digital-coaches/v1/me/photo`, {
    photo,
  })).data;
}

export async function deletePhoto() {
  return (await httpClient.delete<ApiResponse<DigitalCoachProfile>>(`/digital-coaches/v1/me/photo`)).data;
}
